export * from './lib/new-contract/new-contract.component';
